// topLeftMenuSimple.jsx:
import React, { useState, useEffect } from 'react';
import ThemeToggle from './ThemeToggle'
import { useTheme } from '../theme/ThemeContext';
import { saveAsSvg, saveAsPng } from '../utils/download_image';
import QuestionMark from './widgets/questionMarkButton';
import NotificationPopup from './NotificationPopup';

// light theme icons
import backIconLight from '../static/images/black_icons/back_icon_black.png'
import forwardIconLight from '../static/images/black_icons/foward_icon_black.png'
import fitIconLight from '../static/images/black_icons/fit_icon_black.png'
import zoomInIconLight from '../static/images/black_icons/zoom_in_black.png'
import zoomOutIconLight from '../static/images/black_icons/zoom_out_black.png'
import searchIconLight from '../static/images/black_icons/search_icon_black.png'
import colorPickerIconLight from '../static/images/black_icons/color_picker_black.png'
import coordinateIconLight from '../static/images/black_icons/globe_icon_black.png'
import uploadIconLight from '../static/images/black_icons/upload_icon_black.png'
import cameraIconLight from '../static/images/black_icons/camera_black.png'

// dark theme icons 
import backIconDark from '../static/images/back_arrow.png'
import forwardIconDark from '../static/images/forward_arrow.png'
import fitIconDark from '../static/images/reset_fit_icon.png'
import zoomInIconDark from '../static/images/zoom_in.png'
import zoomOutIconDark from '../static/images/zoom_out.png'
import searchIconDark from '../static/images/search_icon.png'
import colorPickerIconDark from '../static/images/color_picker_icon.png'
import coordinateIconDark from '../static/images/target_icon.png'
import uploadIconDark from '../static/images/upload_icon.png'
import cameraIconDark from '../static/images/camera_white.png'


import microverseLogo from '../static/images/microverse_logo_blue.svg'

import SearchBox from './searchBox.jsx';
import ColorBox from './colorBox.jsx';
import CoordinateBox from './coordinateBox.jsx';
import UploadBox from './UploadBox.jsx';

const TopLeftMenuSimple = ({ scatterplot,
    setScatterPointsCategory,
    scatterPointsCategory,
    setScatterColorCategory,
    scatterColorCategory,
    ids,
    historyPointsSelectionStack,
    setHistoryPointsSelectionStack,
    futurePointsSelectionStack,
    setFuturePointsSelectionStack,
    currentPointsSelection,
    setCurrentPointsSelection,
    // isHistoryNavigation,
    // setIsHistoryNavigation, 
    isHistoryNavigationRef,
    setUserID,
    setHighlightTaxon,
    hasUserSamples,
    basePoints }) => {

    const [selectedIcon, setSelectedIcon] = useState(null);
    const [uploadResponse, setUploadResponse] = useState(null);
    const [uploadUserID, setUploadUserID] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [showUploadNotification, setShowUploadNotification] = useState(false);
    const { theme } = useTheme();

    const icons = {
        back: theme.name === 'light' ? backIconLight : backIconDark,
        forward: theme.name === 'light' ? forwardIconLight : forwardIconDark,
        fit: theme.name === 'light' ? fitIconLight : fitIconDark,
        zoomIn: theme.name === 'light' ? zoomInIconLight : zoomInIconDark,
        zoomOut: theme.name === 'light' ? zoomOutIconLight : zoomOutIconDark,
        search: theme.name === 'light' ? searchIconLight : searchIconDark,
        colorPicker: theme.name === 'light' ? colorPickerIconLight : colorPickerIconDark,
        coordinate: theme.name === 'light' ? coordinateIconLight : coordinateIconDark,
        upload: theme.name === 'light' ? uploadIconLight : uploadIconDark,
        camera: theme.name === 'light' ? cameraIconLight : cameraIconDark,
    };

    const divStyleLeft = {
        position: 'fixed',
        top: 0,
        left: 0,
        // margin: '20px',
        // margin: '10px',
        margin: '5px 10px',
        padding: '20px',
        color: '#dadada',
        fontFamily: 'Arial',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        pointerEvents: 'none',
    };

    const logoStyle = {
        width: '200px',
        pointerEvents: 'auto',
    };

    const buttonContainerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        pointerEvents: 'auto',
    };

    const toggleButtonStyle = {
        background: 'none',
        border: 'none',
        color: '#dadada',
        fontSize: '20px',
        cursor: 'pointer',
        padding: '5px',
    };

    const iconStyle = {
        height: '1em',
    };

    const handleReset = () => {
        console.log("reset button pressed");
        if (scatterplot) {
            scatterplot.reset();
        }
    };

    const handleZoomIn = () => {
        console.log("zoom in button pressed");
        if (scatterplot) {
            const currentZoomLevel = scatterplot.get('camera').view[0];
            const newZoom = (1 / currentZoomLevel) - (1 / currentZoomLevel / 3);
            const [x, y] = scatterplot.get('camera').target;
            scatterplot.zoomToLocation([x, y], newZoom, { transition: true });
        }
    };

    const handleZoomOut = () => {
        console.log("zoom out button pressed");
        if (scatterplot) {
            const currentZoomLevel = scatterplot.get('camera').view[0];
            const newZoom = (1 / currentZoomLevel) + (1 / currentZoomLevel / 2);
            // const newZoom = (1 / currentZoomLevel) + (1 / currentZoomLevel / 20);
            const [x, y] = scatterplot.get('camera').target;
            scatterplot.zoomToLocation([x, y], newZoom, { transition: true });
        }
    };

    const handleSearch = () => {
        console.log("search button pressed");
        setSelectedIcon(selectedIcon === 'search' ? null : 'search');
    };

    const handleColor = () => {
        console.log("color selection button pressed");
        setSelectedIcon(selectedIcon === 'color' ? null : 'color');
    };

    const handleCoordinates = () => {
        console.log("coordinate selection button pressed");
        setSelectedIcon(selectedIcon === 'coordinate' ? null : 'coordinate');
    };

    const handleBack = () => {
        // if (historyPointsSelectionStack.length > 0) {
        if (historyPointsSelectionStack.length !== 0) {
            const newHistoryStack = [...historyPointsSelectionStack];
            const previousSelection = newHistoryStack.pop();

            setHistoryPointsSelectionStack(newHistoryStack);

            if (currentPointsSelection !== null) {
                setFuturePointsSelectionStack((prev) => [...prev, currentPointsSelection]);
            }

            if (scatterplot) {
                isHistoryNavigationRef.current = true;

                if (previousSelection !== null) {
                    scatterplot.select(previousSelection);
                    setCurrentPointsSelection(previousSelection);
                } else {
                    scatterplot.deselect();
                    setCurrentPointsSelection(null);
                }
            }
        } else {

            // if (currentPointsSelection !== null) {
            //     setFuturePointsSelectionStack((prev) => [...prev, currentPointsSelection]);
            // }

            isHistoryNavigationRef.current = true;
            scatterplot.deselect();
            console.log("No more history to go back to");
        }
    };

    const handleForward = () => {
        // if (futurePointsSelectionStack.length > 0) {
        if (futurePointsSelectionStack.length !== 0) {
            const newFutureStack = [...futurePointsSelectionStack];
            const nextSelection = newFutureStack.pop();

            setFuturePointsSelectionStack(newFutureStack);

            if (currentPointsSelection !== null) {
                setHistoryPointsSelectionStack((prev) => [...prev, currentPointsSelection]);
            }

            if (scatterplot) {
                isHistoryNavigationRef.current = true;

                if (nextSelection !== null) {
                    scatterplot.select(nextSelection);
                    setCurrentPointsSelection(nextSelection);
                } else {
                    scatterplot.deselect();
                    setCurrentPointsSelection(null);
                }
            }
        } else {
            isHistoryNavigationRef.current = true;
            scatterplot.deselect();
            console.log("No more future selections to go forward to");
            console.log(currentPointsSelection);

        }
    };

    const handleUpload = () => {
        // if (scatterplot) {
        //     saveAsPng(scatterplot)
        // }
        setSelectedIcon(selectedIcon === 'upload' ? null : 'upload');

        console.log("upload button pressed");
        // console.log("upload button pressed, currently disabled");
    };

    const handlePicture = () => {
        if (scatterplot) {
            // saveAsSvg(scatterplot)
            saveAsPng(scatterplot, 1, basePoints.length)
        }
    };

    return (

        <div style={divStyleLeft}>
            <a href="https://www.microverse-cluster.de/en/" target="_blank" rel="noopener noreferrer">
                <img src={microverseLogo} alt="Microverse Logo" style={logoStyle} />
            </a>
            <div style={buttonContainerStyle}>
                {/* <div>
                    <button style={toggleButtonStyle} onClick={handleBack} title="Go Back">
                        <img src={icons.back} alt="toggle" style={{ height: '.6em', opacity: historyPointsSelectionStack.length === 0 ? 0.5 : 1 }} />
                    </button>
                    <button style={toggleButtonStyle} onClick={handleForward} disabled={true} title="Go Forward">
                        <img src={icons.forward} alt="toggle" style={{ height: '.6em', opacity: 0.5 }} />
                    </button>
                </div> */}
                <button style={toggleButtonStyle} onClick={handleReset} title="Reset View">
                    <img src={icons.fit} alt="toggle" style={iconStyle} />
                </button>
                <button style={toggleButtonStyle} onClick={handleZoomIn} title="Zoom In">
                    <img src={icons.zoomIn} alt="toggle" style={iconStyle} />
                </button>
                <button style={toggleButtonStyle} onClick={handleZoomOut} title="Zoom Out">
                    <img src={icons.zoomOut} alt="toggle" style={iconStyle} />
                </button>
                <button style={toggleButtonStyle} onClick={handleSearch} title="Search">
                    <img src={icons.search} alt="toggle" style={iconStyle} />
                </button>
                <button style={toggleButtonStyle} onClick={handleColor} title="Color Scheme">
                    <img src={icons.colorPicker} alt="toggle" style={iconStyle} />
                </button>
                <button style={toggleButtonStyle} onClick={handleCoordinates} title="Select Map">
                    <img src={icons.coordinate} alt="toggle" style={iconStyle} />
                </button>
                <button style={toggleButtonStyle} onClick={handleUpload} title="Upload Data">
                    <img src={icons.upload} alt="toggle" style={iconStyle} />
                </button>
                <button style={toggleButtonStyle} onClick={handlePicture} title="Save PNG Image">
                    <img src={icons.camera} alt="toggle" style={iconStyle} />
                </button>
                <ThemeToggle title="Toggle Theme" />
                <QuestionMark
                    disabled={false}
                    title="Info"
                    style={{ borderRadius: '50%' }}
                />
            </div>
            <div style={{ position: "absolute", top: "100px", left: "100px", pointerEvents: 'auto', }}>
                {selectedIcon === 'search' && <SearchBox
                    scatterplot={scatterplot}
                    ids={ids}
                    setSelectedIcon={setSelectedIcon}
                    setHighlightTaxon={setHighlightTaxon}
                />}
                {selectedIcon === 'color' && <ColorBox
                    scatterplot={scatterplot}
                    setScatterColorCategory={setScatterColorCategory}
                    setSelectedIcon={setSelectedIcon}
                    scatterColorCategory={scatterColorCategory}
                    hasUserSamples={hasUserSamples}
                />}
                {selectedIcon === 'coordinate' && <CoordinateBox
                    scatterplot={scatterplot}
                    setScatterPointsCategory={setScatterPointsCategory}
                    setSelectedIcon={setSelectedIcon}
                    scatterPointsCategory={scatterPointsCategory}
                    hasUserSamples={hasUserSamples}
                />}
                {selectedIcon === 'upload' && <UploadBox
                    scatterplot={scatterplot}
                    setUserID={setUserID}
                    setSelectedIcon={setSelectedIcon}
                    // Pass the lifted state to UploadBox
                    uploadResponse={uploadResponse}
                    setUploadResponse={setUploadResponse}
                    currentUserID={uploadUserID}
                    setCurrentUserID={setUploadUserID}
                    isLoading={isUploading}
                    setIsLoading={setIsUploading}
                    showNotification={showUploadNotification}
                    setShowNotification={setShowUploadNotification}
                />}
            </div>
            <NotificationPopup
                message={`Your User ID: ${uploadUserID}`}
                isVisible={showUploadNotification}
                onClose={() => setShowUploadNotification(false)}
                autoClose={false}
                uploadResponse={uploadResponse}
            />
        </div>
    );
};

export default TopLeftMenuSimple;
